// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-ManageBlackBoxPermissions-styles___h1--gac0S {
  text-align: left;
}

.pages-ManageBlackBoxPermissions-styles___selectWrapperPermissions--HLo7f {
  width: 100%;
  min-width: 150px !important;
}

.pages-ManageBlackBoxPermissions-styles___permissionsBody--jjg_y {
  max-width: 1200px;
  overflow-x: auto;
  border-radius: 4px;
}

.pages-ManageBlackBoxPermissions-styles___agencyNames--GrHat {
  min-width: 200px;
}
`, "",{"version":3,"sources":["webpack://./pages/ManageBlackBoxPermissions/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".h1 {\n  text-align: left;\n}\n\n.selectWrapperPermissions {\n  width: 100%;\n  min-width: 150px !important;\n}\n\n.permissionsBody {\n  max-width: 1200px;\n  overflow-x: auto;\n  border-radius: 4px;\n}\n\n.agencyNames {\n  min-width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h1": `pages-ManageBlackBoxPermissions-styles___h1--gac0S`,
	"selectWrapperPermissions": `pages-ManageBlackBoxPermissions-styles___selectWrapperPermissions--HLo7f`,
	"permissionsBody": `pages-ManageBlackBoxPermissions-styles___permissionsBody--jjg_y`,
	"agencyNames": `pages-ManageBlackBoxPermissions-styles___agencyNames--GrHat`
};
module.exports = ___CSS_LOADER_EXPORT___;
